module.exports = __webpack_public_path__ + "img/safety-summary-icon1.f0d4d00a.svg";